module.exports = __webpack_public_path__ + "static/media/resume.e133e9d5.pdf";